import { Directive } from '@angular/core';

@Directive({
  selector: '[qpointSuggestlistValueTemplate]',
  standalone: true
})
export class QPointSuggestlistValueTemplateDirective {
}
